






















import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { getNewsList } from '../api';

Vue.use(List);

@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;

  created() {
    this.onGetNewsList();
  }

  async onGetNewsList() {
    const classId = '3660';
    if (this.finished) {
      return console.log('no more data');
    }
    this.loading = true;
    const ret = await getNewsList(classId, this.page);
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.list = [...this.list, ...ret.data];
      this.page++;
    } else {
      this.finished = true;
    }
  }
  onNavTo(newsItem: any) {
    if (window.udid && newsItem.dataType !== 7 && newsItem.dataType !== 5) {
      const { id, classId, dataType } = newsItem;
      const option = {
        dt: dataType,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = newsItem.targetUrl;
    }
  }
}
